/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Team_PriceInputs */

const en_mk_price_team_price = /** @type {(inputs: Mk_Price_Team_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp99,000`)
};

const id_mk_price_team_price = /** @type {(inputs: Mk_Price_Team_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp99.000`)
};

/**
* | output |
* | --- |
* | "Rp99,000" |
*
* @param {Mk_Price_Team_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_team_price = /** @type {((inputs?: Mk_Price_Team_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Team_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_team_price(inputs)
	return en_mk_price_team_price(inputs)
});